import {
  DEREGISTER_VIDEO_PLAYER,
  PAUSE,
  PLAY,
  REGISTER_VIDEO_PLAYER
} from '../actions/videoPlayerActions'

const videoPlayer = (state = {}, action) => {
  switch (action.type) {
    case PAUSE:
    case REGISTER_VIDEO_PLAYER:
      return {
        paused: true
      }
    case PLAY:
      return {
        paused: false
      }
    default:
      return state
  }
}

const reducer = (state = {}, action) => {
  switch (action.type) {
    case DEREGISTER_VIDEO_PLAYER:
      const { [action.id]: deletedPlayer, ...rest } = state

      return rest
    case REGISTER_VIDEO_PLAYER:
      return {
        ...state,
        [action.id]: videoPlayer(undefined, action)
      }
    case PLAY:
    case PAUSE:
      return {
        ...state,
        [action.id]: videoPlayer(state[action.id], action)
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ../src/reducers/videoPlayers.js